import { Request } from '../../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../../httpClient/serverApi/types/IResponse';
import {IPrepExtensionsSiteSettings} from '../../../../types/ISiteSettingsForSiteAdmin';

export interface IGetPrepExtensionsSiteSettingsParams {}

export type IGetPrepExtensionsSiteSettingsResult = IResult & IPrepExtensionsSiteSettings;

export class GetPrepExtensionsSiteSettingsRequest extends Request<IGetPrepExtensionsSiteSettingsParams, IGetPrepExtensionsSiteSettingsResult> {
  constructor(params: IGetPrepExtensionsSiteSettingsParams) {
    super('getPrepExtensionsSiteSettings', params);
  }
}
